<div class="col-md-12 project-detail ms-4">
  <div class="row">
    <div class="col-4">
      <div class="d-flex justify-content-start">
        <div><i style="color:#ddd" class="fas fa-5x fa-suitcase"></i></div>
        <div style="margin-left:3%;">
          <h4>{{'GLOBAL.PROJET' | translate | uppercase}}</h4>
          <h4>
            {{projet()?.nom.length >= 22 ? projet().nom.substring(0, 19) + '...' : projet()?.nom }}
          </h4>
        </div>
      </div>
    </div>
    <div class="col-5">
      <div class="row">
        <div class="col">
          <div class="row">
            <table>
              <tbody>
                <tr>
                  <td colspan="2" class="sousTitre">{{'PROJET_DETAIL.DATES_PREV' | translate}}</td>
                </tr>
                <tr>
                  <td>{{'PROJET_DETAIL.DEBUT' | translate}}</td>
                  <td>{{projet()?.dateDebutPrevisionnelle | date: 'dd/MM/yyyy'}}</td>
                </tr>
                <tr>
                  <td>{{'PROJET_DETAIL.FIN' | translate}}</td>
                  <td>{{projet()?.dateFinPrevisionnelle | date: 'dd/MM/yyyy'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col">
          <table>
            <tbody>
              <tr>
                <td colspan="2" class="sousTitre">{{'PROJET_DETAIL.DATES_EFF' | translate}}</td>
              </tr>
              <tr>
                <td>{{'PROJET_DETAIL.DEBUT' | translate}}</td>
                @if (projet()?.dateDebutEffective) {
                  <td>{{projet()?.dateDebutEffective | date: 'dd/MM/yyyy'}}</td>
                }
                @if (!projet()?.dateDebutEffective) {
                  <td>{{'GLOBAL.NON_RENSEIGNE' | translate}}</td>
                }
              </tr>
              <tr>
                <td>{{'PROJET_DETAIL.FIN' | translate}}</td>
                @if (projet()?.dateFinEffective) {
                  <td>{{projet()?.dateFinEffective | date: 'dd/MM/yyyy'}}</td>
                }
                @if (!projet()?.dateFinEffective) {
                  <td>{{'GLOBAL.NON_RENSEIGNE' | translate}}</td>
                }
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="col proj-detail-btn">
      <button *showIfHasRole="'create_project'" type="button" class="btn btn-primary" (click)="ouvrirModaleModif()" style="max-height: 40px;"><i class="fas fa-cog" style="padding-right:5px"></i>{{'GLOBAL.MODIFIER' | translate}}</button>
    </div>
  </div>
  <div class="row">
    <ul class="nav nav-tabs not-selectable proj-item " >
      <li class="nav-item epc-tab">
        <a class="nav-link" (click)="changerTab(1)" [ngClass]="tab() == 1 ? 'active':'' ">
          {{'GLOBAL.DONNEES_ANALYSE' | translate }}
          @if (projet()?.donneeAnalyseRenseignees) {
            <i class="fas fa-check"></i>
          }
        </a>
      </li>
      <!-- <li class="nav-item epc-tab">
      <a class="nav-link" (click)="changerTab(2)" [ngClass]="tab == 2 ? 'active':'' ">{{'GLOBAL.DONNEES_SUIVI_OP' | translate }}</a>
    </li> -->
    <li class="nav-item epc-tab">
      <a class="nav-link" (click)="changerTab(3)" [ngClass]="tab() == 3 ? 'active':'' ">{{'GLOBAL.FICHIERS' | translate }}</a>
    </li>
  </ul>
</div>
<div class="row row-small display">
  @if (tab() == 1) {
    <app-blast-kpi [tabConfigSaisie]="configSaisieSite()" [tabDonneesAnalyse]="donneesAnalyseProjet()" [donneesChargees]="initAnalyseFaite()" [estProjet]="true"
      (rechargerDonnees)="chargerDonneesAnalyse()" [projet]="projet()" class="proj-item" [inProjetDetail] = "true">
    </app-blast-kpi>
  }
  <!-- <ng-container *ngIf="tab == 2">
  <app-donnees-suivi-operationnel [tabDonneesSuivi]="tabRotations" [proprietesAfficheesDonneeSuivi]="propDonneeSuivi" [donneesChargees]="initSuiviFaite" [estProjet]="true" [projet]="projet()"
    (rechargerDonnees)="chargerDonneesSuivi()" class="proj-item">
  </app-donnees-suivi-operationnel>
</ng-container> -->
@if (tab() == 3 && initDossierFaite()) {
  <app-file-explorer [apiEndPoint]="'Projects'" [id]="projet().projetId" [racine]="dossierRacine()" [hauteurExplorer]="hauteurListe" (modifDossier)="modifDossier($event)"
  class="proj-item"></app-file-explorer>
}
</div>
</div>
